// Generated by Scripts/compile-product-event-contract.mjs from the canonical catalogue. Do not edit.

import {
  generatedProductEventSchemas,
  generatedProductEventSchemaVersions,
  type GeneratedProductEventContract,
  type GeneratedProductEventProperties,
} from "./productEventContract.generated";

export const generatedWebProductEventNames = Object.freeze([
    "guest_shared_list_view",
    "guest_shared_list_access_error",
    "guest_shared_list_availability",
    "guest_shared_list_action",
    "guest_shared_list_cta_impression",
    "guest_shared_list_cta_click"
  ] as const);

export type GeneratedWebProductEventName =
  (typeof generatedWebProductEventNames)[number];

const generatedWebProductEventBrand: unique symbol = Symbol(
  "GeneratedWebProductEvent",
);

type GeneratedWebProductEventBrand = {
  readonly [generatedWebProductEventBrand]: true;
};

export type GeneratedWebProductEvent<
  Name extends GeneratedWebProductEventName = GeneratedWebProductEventName,
> = Extract<GeneratedProductEventContract, { name: Name }> &
  GeneratedWebProductEventBrand;

type ExactGeneratedProductEventProperties<Expected, Actual extends Expected> =
  Actual & Record<Exclude<keyof Actual, keyof Expected>, never>;

export type GeneratedWebGuestSharedListViewProperties =
  GeneratedProductEventProperties<"guest_shared_list_view">;
export type GeneratedWebGuestSharedListAccessErrorProperties =
  GeneratedProductEventProperties<"guest_shared_list_access_error">;
export type GeneratedWebGuestSharedListAvailabilityProperties =
  GeneratedProductEventProperties<"guest_shared_list_availability">;
export type GeneratedWebGuestSharedListActionProperties =
  GeneratedProductEventProperties<"guest_shared_list_action">;
export type GeneratedWebGuestSharedListCtaImpressionProperties =
  GeneratedProductEventProperties<"guest_shared_list_cta_impression">;
export type GeneratedWebGuestSharedListCtaClickProperties =
  GeneratedProductEventProperties<"guest_shared_list_cta_click">;

const makeGeneratedWebProductEvent = <Name extends GeneratedWebProductEventName>(
  name: Name,
  properties: Readonly<Record<string, string | boolean>>,
): GeneratedWebProductEvent<Name> => {
  const normalizedProperties: Record<string, string | boolean> = {};
  for (const propertyName of Object.keys(generatedProductEventSchemas[name])) {
    if (Object.hasOwn(properties, propertyName)) {
      normalizedProperties[propertyName] = properties[propertyName];
    }
  }
  const value = {
    name,
    schemaVersion: generatedProductEventSchemaVersions[name],
    properties: Object.freeze(normalizedProperties),
  } as unknown as GeneratedWebProductEvent<Name>;
  Object.defineProperty(value, generatedWebProductEventBrand, {
    value: true,
    enumerable: false,
  });
  Object.freeze(value);
  return value;
};

export const generatedWebProductEvents = Object.freeze({
  "guestSharedListView": <Properties extends GeneratedWebGuestSharedListViewProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListViewProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_view"> =>
    makeGeneratedWebProductEvent("guest_shared_list_view", properties),
  "guestSharedListAccessError": <Properties extends GeneratedWebGuestSharedListAccessErrorProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListAccessErrorProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_access_error"> =>
    makeGeneratedWebProductEvent("guest_shared_list_access_error", properties),
  "guestSharedListAvailability": <Properties extends GeneratedWebGuestSharedListAvailabilityProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListAvailabilityProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_availability"> =>
    makeGeneratedWebProductEvent("guest_shared_list_availability", properties),
  "guestSharedListAction": <Properties extends GeneratedWebGuestSharedListActionProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListActionProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_action"> =>
    makeGeneratedWebProductEvent("guest_shared_list_action", properties),
  "guestSharedListCtaImpression": <Properties extends GeneratedWebGuestSharedListCtaImpressionProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListCtaImpressionProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_cta_impression"> =>
    makeGeneratedWebProductEvent("guest_shared_list_cta_impression", properties),
  "guestSharedListCtaClick": <Properties extends GeneratedWebGuestSharedListCtaClickProperties>(
    properties: ExactGeneratedProductEventProperties<GeneratedWebGuestSharedListCtaClickProperties, Properties>,
  ): GeneratedWebProductEvent<"guest_shared_list_cta_click"> =>
    makeGeneratedWebProductEvent("guest_shared_list_cta_click", properties)
});
